<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';
import PaginationControl from '../PaginationControl/PaginationControl.vue';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';
import AllocationItem from '../AllocationItem/AllocationItem.vue';
import Fake from '../Fake/Fake.vue';

export default Vue.extend({
    components: {
        Fake,
        PaginationControl,
        DropdownMenu,
        AllocationItem
    },
    computed: {
        ...mapState({
            loading: state => state.allocation.list.loading,
            noContent: state => state.allocation.list.noContent,
            error: state => state.allocation.list.error,
            page: state => state.allocation.list.page,
            limit: state => state.allocation.list.limit,
            limitList: state => state.allocation.list.limitList,
            predicate: state => state.allocation.list.predicate,
            predicateList: state => state.allocation.list.predicateList,
            order: state => state.allocation.list.order,
            orderList: state => state.allocation.list.orderList,
            navigationMinimized: state => state.nav.minimized,
            user: state => state.auth.user
        }),
        ...mapGetters({
            filteredAccommodations: 'allocation/filteredAccommodations',
            filteredAccommodationsPaginated: 'allocation/filteredAccommodationsPaginated',
            filteredAccommodationsMaxPages: 'allocation/filteredAccommodationsMaxPages'
        })
    },
    methods: {
        ...mapActions({
            incrementPage: 'allocation/incrementPage',
            decrementPage: 'allocation/decrementPage',
            setPredicate: 'allocation/setPredicate',
            setLimit: 'allocation/setLimit',
            setOrder: 'allocation/setOrder',
            setAccommodation: 'allocation/setAccommodation',
        })
    }
});
</script>
<template>
    <div class="allocation-list">
        <transition name="fade" mode="out-in">
            <div v-if="!loading && filteredAccommodations.length"
                 :key="'body'"
                 class="allocation-list__body">
                <div :class="{'allocation-list__header--minimized': !navigationMinimized}"
                     class="allocation-list__header">
                    <div class="allocation-list__heading">
                        {{ $tc('allocationList.heading', filteredAccommodations.length, {count: filteredAccommodations.length}) }}
                    </div>
                    <div class="allocation-list__option allocation-list__option--pagination">
                        <pagination-control :max-pages="filteredAccommodationsMaxPages"
                                            :current-page="page"
                                            @prev="decrementPage"
                                            @next="incrementPage"/>
                    </div>
                    <div class="allocation-list__option">
                        <dropdown-menu
                            :label="$t('allocationList.orderBy')"
                            :value="predicate"
                            :items="predicateList"
                            :translation-prefix="'allocationList.tableFields'"
                            @input="setPredicate($event)"/>
                    </div>
                    <div class="allocation-list__option">
                        <dropdown-menu
                            :label="$t('allocationList.order')"
                            :value="order"
                            :items="orderList"
                            :translation-prefix="'allocationList.orderFields'"
                            @input="setOrder($event)"/>
                    </div>
                    <div class="allocation-list__option">
                        <dropdown-menu
                            :label="$t('allocationList.perPage')"
                            :value="limit"
                            :items="limitList"
                            @input="setLimit($event)"/>
                    </div>
                </div>
                <table class="allocation-list__table">
                    <thead>
                        <tr>
                            <th>{{ $t('allocationList.tableFields.name') }}</th>
                            <th v-if="user.contractManager">
                                {{ $t('allocationList.tableFields.supplier') }}
                            </th>
                            <th>{{ $t('allocationList.tableFields.site') }}</th>
                            <th>{{ $t('allocationList.tableFields.updatedAt') }}</th>
                            <th>{{ $t('allocationList.tableFields.updatedBy') }}</th>
                            <th/>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <tr v-for="allocation in filteredAccommodationsPaginated" :key="allocation.accommodationSiteId">
                            <td>{{ allocation.name }}</td>
                            <td v-if="user.contractManager">{{ allocation.supplier }}</td>
                            <td>{{ allocation.site }}</td>
                            <td>
                                <span v-if="allocation.updatedAt">
                                    {{ allocation.updatedAt | moment("DD/MM/Y\, HH:mm") }}
                                </span>
                            </td>
                            <td>{{ allocation.userName }}</td>
                            <td align="right">
                                <router-link :to="{name: 'manageAccommodationAllocation', params: { siteId: allocation.siteId, accommodationSiteId: allocation.accommodationSiteId }}"
                                             class="allocation-list__button">
                                    <i v-if="allocation.pendingRequests" class="fa fa-exclamation-triangle"/>
                                    {{ $t('allocationList.button.update') }}
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!loading" class="allocation-list__items">
                    <div class="allocation-list__items-list">
                        <allocation-item v-for="allocation in filteredAccommodationsPaginated"
                                         :key="allocation.accommodationSiteId"
                                         :name="allocation.name"
                                         :supplier="allocation.supplier"
                                         :updated-at="allocation.updatedAt"
                                         :updated-by="allocation.userName"
                                         :site-id="allocation.siteId"
                                         :accommodation-site-id="allocation.id"
                                         :site="allocation.site"/>
                    </div>
                </div>
                <div class="allocation-list__footer">
                    <div v-if="!loading" class="allocation-list__pagination">
                        <pagination-control :max-pages="filteredAccommodationsMaxPages"
                                            :current-page="page"
                                            @prev="decrementPage"
                                            @next="incrementPage"/>
                    </div>
                </div>
            </div>
            <div v-if="!loading && error"
                 :key="'error'"
                 class="allocation-list__error">
                <i class="fa fa-exclamation-circle"/>
                <div class="allocation-list__error-message">
                    {{ $t('allocationList.messages.error') }}
                </div>
            </div>
            <div v-if="!loading && !error && (noContent || !filteredAccommodations.length)"
                 :key="'no-content'"
                 class="allocation-list__error">
                <i class="fa fa-warning"/>
                <div class="allocation-list__error-message">
                    {{ $t('allocationList.messages.noContent') }}
                </div>
            </div>
            <fake v-if="loading"
                  :header-rows="1"
                  :body-rows="12"
                  :body-cells="4"
                  :key="'fake'"/>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AllocationList/AllocationList.vue